<template>
    <div class="invoiceHistoryWrap">
        <div class="formWrap">
            <el-form :inline="true">
                <el-form-item label="申请日期">
                    <el-date-picker
                        v-model="time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="发票状态">
                    <el-select placeholder="全部" v-model="status"> 
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待开票" value="2"></el-option>
                        <el-option label="已开票" value="5"></el-option>
                        <el-option label="待冲红" value="8"></el-option>
                        <el-option label="已冲红" value="9"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="goSearch()" type="primary">查询</el-button>
                </el-form-item>
            </el-form>
        </div>    
        <div class="tableWrap">
            <el-table
                style="width: 100%"
                v-loading="tableLoading"
                :data="invoiceApplyRecords"
                stripe
            >
                <el-table-column 
                    label="申请日期"
                    width="170px"
                    prop="applyTime"
                >
                </el-table-column>
                <el-table-column
                    label="申请人"
                    width="80px"
                    prop="applicantName"
                >
                </el-table-column>
                <el-table-column
                    label="发票抬头"
                    prop="invoiceTitle"
                >
                </el-table-column>
                <el-table-column
                    label="金额(元)"
                    width="120px"
                    prop="applyAmount"
                >
                </el-table-column>
                <el-table-column
                    label="发票类型"
                    width="120px"
                    prop="invoiceTypeStr"
                >
                </el-table-column>
                <el-table-column
                    width="120px"
                    label="发票状态"
                    prop="applyStatus"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus===2">
                            <span class="invoceState"><i class="status2"></i><span>待开票</span></span>
                        </div>
                        <div v-else-if="scope.row.applyStatus===5">
                            <span class="invoceState"><i class="status5"></i><span>已开票</span></span>
                        </div>
                        <div v-else-if="scope.row.applyStatus===8">
                            <span class="invoceState"><i class="status8"></i><span>待冲红</span></span>
                        </div>
                        <div v-else-if="scope.row.applyStatus===9">
                            <span class="invoceState"><i class="status9"></i><span>已冲红</span></span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="120px"
                    prop="applyStatus"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus ==5 ">
                            <a href="javascript:void(0)" class="downloadBtn" @click="downloadInvoice(scope.row.applyId)">下载发票</a>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            
        </div>
        <div class="paginationWrap" v-if="invoiceApplyRecords.length >0">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :total="RecordsTotal"
                    :page-sizes="[5,10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next,sizes"
                    background
                >
            </el-pagination>
        </div>
        <div
            class="noRecordsWrap"
            v-if="invoiceApplyRecords.length == 0 && tableLoading == false"
        >
                <h4>暂无发票记录</h4>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import { Message } from 'element-ui'
export default {
    beforeMount: function () {
        if (this.$store.state.header.selfGroup && Object.keys(this.$store.state.header.selfGroup).length > 0) {
            this.getRecords()
		}
	},
    data () {
        return {
            time:'',
            status:'',
            pageNum:1,
            pageSize:20
        }
    },
    computed: {
        ...mapState('invoice', [
        'invoiceApplyRecords',
        'RecordsTotal',
        'tableLoading'
        ])
    },
    methods: {
        getRecords:function(){
            console.log('this.time',this.time)
            this.$store.commit('invoice/openLoading')
            let startTime = this.time ? this.time[0] :''
            let endTime = this.time ? this.time[1] :''
            this.$store.dispatch('invoice/getInvoiceApplyRecords', {
                groupId: this.$store.state.header.selfGroup.groupId,
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                startTime,
                endTime,
                status:this.status,
            })
        },
        handleSizeChange: function (val) {
            this.pageSize = val
            this.pageNum = 1
            this.getRecords()
        },
        handleCurrentChange: function (val) {
            this.pageNum = val
            this.getRecords()
        },
        goSearch:function(){
            this.pageNum = 1
            this.getRecords()
        },
        downloadInvoice:function(applyId){
            this.$store.dispatch('invoice/downloadInvoice', {applyId,groupId: this.$store.state.header.selfGroup.groupId})
        }
    },
    watch: {
    }
}
</script>

<style lang="stylus">
.invoiceHistoryWrap
    padding 20px    
    .formWrap
        padding-left 20px
        .el-input__inner
            border-radius 0
            border 1px solid #ccc
    .paginationWrap
        text-align right
        padding-top 20px
        .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
            border-radius 0
        .el-pagination.is-background .el-pager li:not(.disabled).active
            background #3468FF
        .el-pagination .el-select .el-input .el-input__inner
            height 28px
            line-height 28px
            border-radius 0
    .invoceState
        position relative
        display flex
        flex-direction row
        align-items center
        justify-content center
        i
            width: 6px
            height: 6px
            display inline-block
            margin-right 4px
        .status2
            background-color #4DBF84
        .status5
            background-color #3468FF
        .status8
            background-color #FF8252
        .status9
            background-color #ccc
    .downloadBtn
        text-decoration none
        color #3468FF
.noRecordsWrap
  width 560px
  margin 100px auto 0
  text-align center
  h4
    font-size 20px
    font-weight 500
    text-align center
    margin 0 0 20px 0
    background-image url('../../images/billnodata.png')
    background-position top center
    background-size 120px
    padding-top 150px
    background-repeat no-repeat
.el-table__empty-block
    display none
</style>
